import React from "react";

import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';

import Card from 'react-bootstrap/Card';

import ExcelJS from "exceljs";
import saveAs from "file-saver";

import { RiskLevels, ConsequenceLevels, ProbabilityLevels } from './RiskLevels'

import UserContext from '../context/UserContext';


class RiskReportDialog extends React.Component {

	static contextType = UserContext;

	state = {
		reportName: '',
		fromDate: new Date(),
		toDate: new Date(),
		controlList: [],
	};


	componentDidMount() {
		
		var currentDate = new Date(this.state.toDate.getTime());
		this.setState({ controlList: this.props.controlList });
		if (Object.prototype.toString.call(this.props.toDate) === "[object Date]") {
			this.setState({ toDate: new Date(this.props.toDate.getTime()) });

			currentDate = new Date(this.props.toDate.getTime());
			currentDate.setFullYear(currentDate.getFullYear() - 1);
			this.setState({ fromDate: currentDate });
		} else {
			currentDate.setFullYear(currentDate.getFullYear() - 1);
			this.setState({ fromDate: currentDate });
		}
		 
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			this.setState({ controlList: this.props.controlList });
			if (Object.prototype.toString.call(this.props.toDate) === "[object Date]") {
				this.setState({ toDate: new Date(this.props.toDate.getTime()) });
				
				var currentDate = this.props.toDate;
				currentDate.setFullYear(currentDate.getFullYear() - 1);
				this.setState({ fromDate: currentDate });
			}			
		}
	}


	fetchReport() {	
		this.setState({ isLoadingData: true });
		var reportReuest = { controlList: this.state.controlList, name: this.state.reportName, fromDate: this.state.fromDate, toDate: this.state.toDate };
		
		fetch('api/Report/GetControlReport', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(reportReuest) })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.excelExport(data);
				this.closeDialog();
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoadingData: false });
			})
	}

	excelExport(controlReport) {
		var ExcelJSWorkbook = new ExcelJS.Workbook();

		var reportName = this.state.reportName;

		this.controlPage(ExcelJSWorkbook, controlReport);
		this.testPage(ExcelJSWorkbook, controlReport);
		this.taskPage(ExcelJSWorkbook, controlReport);

		//Save excel file	
		ExcelJSWorkbook.xlsx.writeBuffer().then(function (buffer) {
			saveAs(
				new Blob([buffer], { type: "application/octet-stream" }),
				reportName + '.xlsx'
			);
		});
	}

	taskPage(ExcelJSWorkbook, controlReport) {
		var worksheet = ExcelJSWorkbook.addWorksheet("WorkNodes tasks");
		var rows = 0;

		worksheet.getColumn(1).width = 35;
		worksheet.getColumn(2).width = 35;
		worksheet.getColumn(3).width = 25;
		worksheet.getColumn(4).width = 15;
		worksheet.getColumn(5).width = 15;
		worksheet.getColumn(6).width = 20;
		worksheet.getColumn(7).width = 45;

		worksheet.getCell('A2').value = "Control"
		worksheet.getCell('A2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('A2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('B2').value = "Task"
		worksheet.getCell('B2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('B2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('C2').value = "Status"
		worksheet.getCell('C2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('C2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('D2').value = "Closing date"
		worksheet.getCell('D2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('D2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('E2').value = "Deadline"
		worksheet.getCell('E2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('E2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('F2').value = "Closed by"
		worksheet.getCell('F2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('F2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('G2').value = "Closing comment"
		worksheet.getCell('G2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('G2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		for (let i = 0; i < controlReport.length; i++) {
			var control = controlReport[i];
			for (let j = 0; j < control.taskReport.length; j++) {
				var task = control.taskReport[j];

				rows++;

				var currentRow = worksheet.addRow();
				currentRow.alignment = { vertical: 'top' };

				var rowHeight = Math.ceil(task.comment.length / 40) * 15;
				currentRow.height = rowHeight;

				currentRow.getCell(1).value = control.name;
				currentRow.getCell(2).value = task.taskName;
				//currentRow.getCell(3).value = task.statusName;

				currentRow.getCell(3).value = {
					richText: [
						{ font: { color: { argb: 'FF' + task.colorCode.substring(1) } }, text: '■ ' },
						{ font: { bold: false }, text: task.statusName },
					]
				};

				currentRow.getCell(4).value = task.closeTime.split('T')[0];
				currentRow.getCell(5).value = task.deadline.split('T')[0];
				currentRow.getCell(6).value = task.closerName;
				currentRow.getCell(7).value = task.comment;
				currentRow.getCell(7).alignment = { wrapText: true, vertical: 'top' };
			}
		}

		worksheet.autoFilter = {
			from: {
				row: 2,
				column: 1
			},
			to: {
				row: rows + 2,
				column: 6
			}
		}
	}

	testPage(ExcelJSWorkbook, controlReport) {
		var worksheet = ExcelJSWorkbook.addWorksheet("Testing");
		var rows = 0;

		worksheet.getColumn(1).width = 25;
		worksheet.getColumn(2).width = 35;
		worksheet.getColumn(3).width = 20;
		worksheet.getColumn(4).width = 20;
		worksheet.getColumn(5).width = 15;
		worksheet.getColumn(6).width = 15;
		worksheet.getColumn(7).width = 25;
		worksheet.getColumn(8).width = 35;

		worksheet.getCell('A2').value = "Control"
		worksheet.getCell('A2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('A2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('B2').value = "Test"
		worksheet.getCell('B2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('B2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('C2').value = "Test responsible"
		worksheet.getCell('C2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('C2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('D2').value = "Test frequency"
		worksheet.getCell('D2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('D2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('E2').value = "Date"
		worksheet.getCell('E2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('E2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('F2').value = "Status"
		worksheet.getCell('F2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('F2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('G2').value = "Signed by"
		worksheet.getCell('G2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('G2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('H2').value = "Comment"
		worksheet.getCell('H2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('H2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		for (let i = 0; i < controlReport.length; i++) {
			var control = controlReport[i];
			for (let j = 0; j < control.testReports.length; j++) {
				var test = control.testReports[j];

				rows++;

				var currentRow = worksheet.addRow();
				currentRow.alignment = { vertical: 'top' };

				var rowHeight = Math.max(Math.ceil(test.comment.length / 40), Math.ceil(control.testInstruction.length / 40)) * 15 ;
				currentRow.height = rowHeight;

				currentRow.getCell(1).value = control.name;
				currentRow.getCell(2).value = control.testInstruction;
				currentRow.getCell(2).alignment = { wrapText: true, vertical: 'top' };
				currentRow.getCell(3).value = control.tester;
				currentRow.getCell(4).value = control.testFrequency;
				currentRow.getCell(5).value = test.date.split('T')[0];

				currentRow.getCell(6).value = {
					richText: [
						{ font: { color: { argb: 'FF' + test.colorCode.substring(1) } }, text: '■ ' },
						{ font: { bold: false }, text: test.status },
					]
				};

				currentRow.getCell(7).value = test.tester;
				currentRow.getCell(8).value = test.comment;
				currentRow.getCell(8).alignment = { wrapText: true, vertical: 'top' };
			}
		}

		worksheet.autoFilter = {
			from: {
				row: 2,
				column: 1
			},
			to: {
				row: rows + 2,
				column: 7
			}
		}
	}

	controlPage(ExcelJSWorkbook, controlReport) {
		var worksheet = ExcelJSWorkbook.addWorksheet("Internal control structure");

		worksheet.views = [{
			showGridLines: false
		}];

		worksheet.getRow(1).height = 36;
		worksheet.getRow(2).height = 27;
		worksheet.getRow(2).alignment = { vertical: 'middle', horizontal: 'center' };

		worksheet.getColumn(1).width = 28;
		worksheet.getColumn(2).width = 35;
		worksheet.getColumn(3).width = 35;
		worksheet.getColumn(4).width = 40;
		worksheet.getColumn(5).width = 35;
		worksheet.getColumn(6).width = 15;
		worksheet.getColumn(7).width = 15;
		worksheet.getColumn(8).width = 35;
		worksheet.getColumn(9).width = 35;
		worksheet.getColumn(10).width = 35;

		worksheet.getCell('A2').value = "Process/Area"
		worksheet.getCell('A2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('A2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('B2').value = "Category"
		worksheet.getCell('B2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('B2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('C2').value = "Risk"
		worksheet.getCell('C2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('C2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('D2').value = "Control"
		worksheet.getCell('D2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('D2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('E2').value = "Control performer"
		worksheet.getCell('E2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('E2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('F2').value = "Frequency"
		worksheet.getCell('F2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('F2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('G2').value = "IT dependencies"
		worksheet.getCell('G2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('G2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('H2').value = "Testing"
		worksheet.getCell('H2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('H2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('I2').value = "Test responsible"
		worksheet.getCell('I2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('I2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		worksheet.getCell('J2').value = "Test frequency"
		worksheet.getCell('J2').font = { bold: true, color: { argb: 'FFFFFFFF' } };
		worksheet.getCell('J2').fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FF57758C' }
		};

		for (let i = 0; i < controlReport.length; i++) {
			var control = controlReport[i];

			var currentRow = worksheet.addRow();
			currentRow.alignment = { vertical: 'top' };

			var rowHeight = (Math.ceil(control.description.length / 42) + Math.ceil(control.supportingEvidence.length / 42) + 7) * 15;
			currentRow.height = rowHeight;

			currentRow.getCell(1).value = control.process;
			currentRow.getCell(2).value = control.riskType;
			currentRow.getCell(3).value = control.riskName;

			currentRow.getCell(4).alignment = { wrapText: true, vertical: 'top' };
			currentRow.getCell(4).value = {
				richText: [
					{ font: { bold: true }, text: control.name },
					{ text: '\n' },
					{ font: { bold: false }, text: control.controlType + ' ' + control.dependencyType },
					{ text: '\n' },
					{ text: '\n' },
					{ font: { bold: true }, text: 'Control description'},
					{ text: '\n' },
					{ font: { bold: false }, text: control.description },
					{ text: '\n' },
					{ text: '\n' },
					{ font: { bold: true }, text: 'Supporting evidence' },
					{ text: '\n' },
					{ font: { bold: false }, text: control.supportingEvidence },
				]
			};

			if (control.dependencyType === 'Automated') {
				currentRow.getCell(5).value = 'N/A - automated control. Control setup owned by ' + control.taskResponsible;
				currentRow.getCell(5).alignment = { wrapText: true, vertical: 'top' };
			} else {
				currentRow.getCell(5).value = control.taskResponsible;
			}

			if (control.taskIsWN) {
				currentRow.getCell(6).value = 'N/A - control scheduled in WorkNodes';
				currentRow.getCell(6).alignment = { wrapText: true, vertical: 'top' };
				currentRow.getCell(7).value = 'WorkNodes';
			} else {
				currentRow.getCell(6).value = control.taskTrigger;
				currentRow.getCell(7).value = control.supportingSystem;
			}
			
			currentRow.getCell(8).value = control.testInstruction;
			currentRow.getCell(8).alignment = { wrapText: true, vertical: 'top' };

			if (control.tester === '') {
				currentRow.getCell(9).value = 'N/A';
			} else {
				currentRow.getCell(9).value = control.tester;
			}


			if (control.testFrequency === '') {
				currentRow.getCell(10).value = 'N/A';
			} else {
				currentRow.getCell(10).value = control.testFrequency;
			}


		}

		worksheet.autoFilter = {
			from: {
				row: 2,
				column: 1
			},
			to: {
				row: controlReport.length+2,
				column: 10 
			}
		}
	}

	closeDialog() {
		if (this.props.onClose != null) {
			this.props.onClose(false);
			this.setState({ reportName: '', fromDate: new Date(), toDate: new Date(), riskList: [] });
		}
	}



	
	render() {

		const footerContent = (
			<div>
				<div style={{ float: 'left' }}>
					
				</div>
				<div style={{ float: 'right' }}>
					<Button label="Close" icon="pi pi-times" onClick={() => this.closeDialog()} className="p-button-secondary" />
					<Button label="Create & Download" icon="pi pi-cloud-download" onClick={() => this.fetchReport()} disabled={this.state.reportName===''} />
				</div>
			</div>
		);


		return (
			<Dialog header="Risk report" visible={this.props.visible}  footer={footerContent}
				modal contentStyle={{ minHeight: '300px', maxWidth:'25rem' }} closable={false} >
				<ConfirmDialog />

				<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto' }}>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }}>
						<Card.Header>
							<b>Report name</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem">
								<div className="p-field">
									<InputText value={this.state.reportName} maxLength="50" onChange={(e) => { this.setState({ reportName: e.target.value})  }} className="w-full md:w-20rem" />
								</div>

							</div>
						</Card.Body>
					</Card>

					<Card className='rounded' style={{ minWidth: '20rem', marginRight: '1.5rem', marginBottom: '1.5rem' }}>
						<Card.Header>
							<b>Report period</b>
						</Card.Header>
						<Card.Body>
							<div className="p-fluid md:w-20rem">

								<div className="p-field">
									<label className="p-field-label">From date</label>
									<Calendar value={this.state.fromDate} onChange={(e) => null} dateFormat="yy-mm-dd" showIcon  />
								</div>

								<div className="p-field">
									<label className="p-field-label">To date</label>
									<Calendar value={this.state.toDate} onChange={(e) => null} dateFormat="yy-mm-dd"  disabled />
								</div>
								
							</div>
						</Card.Body>
					</Card>
				</div>
			</Dialog>
		);
	}
}
export default (RiskReportDialog);